<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Code:</label>
	<input class="form-control" type="text" placeholder="Code or Abbreviation" [(ngModel)]="MeritCD" />

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="Name or Description" [(ngModel)]="MeritDesc" />

	<label>Merit/Demerit:</label>
	<div class="MeritRadio">
		<input id="Merit" value="0" name="IsDemerit" [(ngModel)]="IsDemerit" style="margin: 2px 0px 0px" type="radio" />
		<label for="Merit" style="margin: 0px">Merit</label>

		<input id="Demerit" value="1" name="IsDemerit" [(ngModel)]="IsDemerit" style="margin: 2px 0px 0px" type="radio" />
		<label for="Demerit" style="margin: 0px">Demerit</label>
	</div>

	<label>Merit/Demerit Value:</label>
	<input class="form-control" type="number" [(ngModel)]="DefaultValue" />

	<label>Minimum Value:</label>
	<input class="form-control" type="number" [(ngModel)]="MinValue" />

	<label>Maximum Value:</label>
	<input class="form-control" type="number" [(ngModel)]="MaxValue" />

	<label for="EDCRAssignable">Can be added from Classroom</label>
	<input id="EDCRAssignable" class="form-control" type="checkbox" [(ngModel)]="EDCRAssignable" />

	<label for="QuickMerit">Quick Merit</label>
	<input id="QuickMerit" class="form-control" type="checkbox" [(ngModel)]="QuickMerit" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdateMerit()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
